import { useOpenLinkPrompt } from '../insertButtonHooks/useOpenLinkPrompt'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertLinkButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const openPrompt = useOpenLinkPrompt(view)
  const onClick = () => {
    openPrompt()
    dropdownStore?.hardClose()
  }

  return <SingleMenuDropdownItem icon={<ToolbarIcon name={IconName.LinkAngled} />} label="Link" handleClick={onClick} />
}
